module.exports = __webpack_public_path__ + "static/andrej-lisakov-g3z-CgUiPtg-unsplash-45e54a69703e4609122b86db01729fb6.jpg";